import { Info } from 'ui/components'
import { LicenseStatusPanel } from '~bank-crb-monitor/components/LicenseStatusPanel'

import { useCRBIdLicenseContext } from '../../CRBIdLicenseContext'

import { s } from './styles'

export const LicensePanel = () => {
  const { data } = useCRBIdLicenseContext()

  const { licensee, licenseIdentifier } = data

  return (
    <s.Wrapper>
      {licensee && (
        <Info label="Licensee" withoutPaddingBottom>
          <s.Text>{licensee}</s.Text>
        </Info>
      )}
      {licenseIdentifier && (
        <Info label="License #" withoutPaddingBottom>
          <s.Text>{licenseIdentifier}</s.Text>
        </Info>
      )}
      <LicenseStatusPanel showHintType={data.showHintType} showHintMessage={data.showHintMessage} />
    </s.Wrapper>
  )
}
